export var rowsPerPageOptions = [
    { value: 10, label: 10 },
    { value: 20, label: 20 },
    { value: 50, label: 50 },
    { value: 100, label: 100 }
];
export var gridButtonStripHeight = 75;
export var gridHeadHeight = 40;
export var gridFilterHeight = 39;
export var gridFooterHeight = 60;
export var gridRowHeight = 40;
